import React, { PureComponent } from 'react';

import './printable.scss';

export default class Invoice extends PureComponent {
  render() {
    return (
      <div className="a4 printable">
        <div className="a4 grid">
          {Array.from({ length: 42 * 59 }, (_, i) => (
            <div className="grid-item" key={i}></div>
          ))}
        </div>
        <div className="a4 page"></div>
      </div>
    );
  }
}
